import { Bubble, Prompts } from "@ant-design/x";
import { Button, Card } from "antd";
import styled from "styled-components";

export const StyledContainer = styled(Card)`
  width: 100%;
  height: 90dvh;
  border-radius: 0.75rem;
  border: 1px solid var(--main-color);
  box-shadow: -0.25rem 0.25rem 0.25rem 0 #0000000D;
  overflow: hidden;
  position: relative;

  .ant-card-head {
    background-color: #fff;
    border: none;
    box-shadow: 0 1px 0 0 #0000001a;
  }

  .ant-card-body {
    padding: 1rem;
    overflow-y: auto;
    position: relative;
    height: calc(90dvh - 7.5rem);

    @media screen and (min-width: 48em) {
      height: calc(100% - 7.5rem);
    }

    &::-webkit-scrollbar {
      width: 0.25rem;
    }

    &::-webkit-scrollbar-track {
      background: rgb(234, 237, 240);
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--main-color);
      border-radius: 0.25rem;
    }
  }

  .ant-card-actions {
    padding: 0.5rem;
    align-items: center;
    justify-content: center;
    border: none;
    box-shadow: 0 -1px 0 0 #0000001a;

    li {
      margin: 0;
    }

    .ant-sender-content {
      padding-block: 0.5rem;
    }
  }

  @media screen and (min-width: 48em) {
    width: 45rem;
    height: 27rem !important;
  }
`;

export const StyledBubbleList = styled(Bubble.List)`
  .ant-bubble-end,
  .ant-bubble-start {
    max-width: 85%;
    border-radius: 1rem;
    font-size: 1.125rem;
  }

  .ant-bubble-footer {
    margin-top: 0.125rem;
  }

  .ant-bubble-end {
    margin-left: auto;

    .ant-bubble-content {
      background: linear-gradient(90.88deg, #0076ff 0.76%, #3d97ff 100%);
      color: #fff;

      a {
        color: #fff;
      }
    }
  }

  .ant-bubble-start {
    margin-right: auto;

    &[role='SYSTEM'] {
      margin-inline: auto;
      .ant-bubble-content {
        padding-inline: 2rem;
        background: #fdfac7;
        color: #0d0a0a;
      }
    }
  }
` as typeof Bubble.List;

export const StyledPrompts = styled(Prompts)`
  width: 100%;
  padding-block-start: 1rem;

  .ant-prompts-item {
    padding: 0.5rem;
    border-radius: 99em;
    min-width: 2.5rem;
    border: 1px solid #0076ff;

    &:hover {
      background-color: #0076ff !important;
      .ant-prompts-label {
        color: #fff !important;
      }
    }

    .ant-prompts-content {
      align-items: center;
    }
  }
`;

export const StyledCloseButton = styled(Button)`
  .anticon {
    font-size: var(--size);
  }
`;

export const StyledName = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #0d0a0a;
`;

export const StyledInfo = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: #0d0a0a;
  opacity: 0.5;
  font-weight: 400;
`;

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledTime = styled.time`
  font-size: 0.75rem;
  line-height: 1.25;
  color: #0d0a0a;
  opacity: 0.5;
`;

export const StyledBlock = styled.div`
  display: flex;
  gap: 0.5rem;

  .anticon {
    font-size: 2rem;
  }
`;
